<template>
  <v-app :id="isUcm ? 'inspire' : isTnk ? 'wisata' : 'bangsal'">
    <component :is="layout"></component>
    <toast ref="toast"></toast>
    <confirmation ref="confirm"></confirmation>
    <popup-notifikasi ref="notifikasi"></popup-notifikasi>
  </v-app>
</template>

<script>
import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import Splash from '@layouts/Splash';
import Dasbor from '@layouts/Dasbor';
import Layout from '@layouts/FullLayout';
import Maintenance from '@layouts/Maintenance';
import PopupNotifikasi from '@components/popup/Notifikasi.vue';
export default {
  name: 'App',
  components: {
    Dasbor,
    Splash,
    Maintenance,
    Layout,
    PopupNotifikasi,
  },
  data: () => ({
    themes: {
      desa: {
        light: {
          primary: '#4EAE51',
          secondary: '#E1F1E4',
          accent: '#82B1FF',
        },
      },
      bangsal: {
        light: {
          primary: '#0059AF',
          secondary: '#DEEEFF',
        },
      },
      wisata: {
        light: {
          primary: '#6D0307',
          secondary: '#FFE9EB',
          accent: '#82B1FF',
        },
      },
    },
  }),
  computed: {
    ...mapState(['loading']),

    ...mapState('preferensi', {
      isTnk: (state) => state.is_tnk || false,
      preferensi: (state) => state.preferensi || {},
    }),

    ...mapGetters({
      isUcm: 'auth/isUcm',
    }),

    layout() {
      return Number(process.env.VUE_APP_MAINTENANCE)
        ? Maintenance
        : this.loading
        ? 'Splash'
        : this.$route.meta.layouts || 'Dasbor';
    },
  },
  mounted() {
    Vue.prototype.$toast = (color, text, options = {}) => {
      this.$refs.toast.show({ color, text, ...options });
    };

    Vue.prototype.$closeToast = () => {
      this.$refs.toast.close();
    };

    Vue.prototype.$confirm = this.$refs.confirm.open;

    Vue.prototype.$notifikasi = (message, title, options = {}) => {
      return this.$refs.notifikasi.open(message, title, options);
    };

    Vue.prototype.$error = (message, button, color) => {
      this.$toast(color || '#E53935', message, {
        icon: 'mdi-alert',
        timeout: 0,
        button: button,
      });
    };

    Vue.prototype.$info = (message) => {
      this.$toast('#1E88E5', message, {
        icon: 'mdi-information',
        timeout: 5000,
      });
    };

    Vue.prototype.$success = (message) => {
      this.$toast('#2E7D32', message, {
        icon: 'mdi-check-circle',
        timeout: 5000,
      });
    };

    this.setTheme();
  },
  methods: {
    setTheme() {
      this.$vuetify.theme.themes.light = Object.assign(
        {},
        this.$vuetify.theme.themes.light,
        this.themes[this.isUcm ? 'desa' : this.isTnk ? 'wisata' : 'bangsal'].light
      );
    },
    checkEmailBlock() {
      const email = this.$getDeepObj(this.preferensi, 'akun.attributes.email');
      const block = [
        // 'adminkemuning@smartvillagenusantara.id',
        'adminpangandaran@smartvillagenusantara.id',
        'adminranupane@smartvillagenusantara.id',
        'adminsambirejo@smartvillagenusantara.id',
        'adminsambirejo@smartvillagenusantara.id',
      ];
      if (block.includes(email)) {
        this.$refs.notifikasi.open(
          "<div class='black--text'> Kami telah membatasi akses login anda sebagai admin dilayanan ini karena masa layanan sudah tidak aktif, anda tetap bisa mengakses layanan ini sebagai pengawas saja, untuk berlangganan layanan kembali silahkan hubungi admin atau Telkom terdekat</div>",
          'Perhatian!',
          {
            noIcon: true,
          }
        );
      }
    },
  },
  watch: {
    isUcm: 'setTheme',
    isTnk: 'setTheme',
    preferensi: 'checkEmailBlock',
  },
};
</script>
